export enum UploadType {
    Unspecified = 'Unspecified',
    ProductInventory = "ProductInventory",
    ProductInformation = "ProductInformation",
    ProductMainsAndSubs = "ProductMainsAndSubs",
    ProductKits = "ProductKits",
    ProductCaseConfigurations = "ProductCaseConfigurations",
    ProductSuppliers = "ProductSuppliers",
    ProductTags = "ProductTags",
    ProductActiveStatus = "ProductActiveStatus",
    OrderInformation = "OrderInformation",
    ProductPackageBoxConfigurations = "ProductPackageBoxConfigurations",
    OrderAdditionalFees = "OrderAdditionalFees",
    ReturnsByOrderNumber = "ReturnsByOrderNumber",
    TargetReferralFees = 'TargetReferralFees',
    AdvertisingCosts = 'AdvertisingCosts',
    TargetItemTypes = 'TargetItemTypes',
    TargetProductMappings = 'TargetProductMappings',
    AdvertisingCampaignMappings = 'AdvertisingCampaignMappings'
}